import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import styles from './TheHype.module.css';

export default function TheHype() {
  return (
    <div className={styles.container}>
      <Helmet>
        <title>The Hype | MyPeopleDatabase</title>
        <meta
          name="description"
          content="The Hype: a new platform is coming. Own your relationships and solve your people-data problems now."
        />
      </Helmet>

      <div className={styles.content}>
        <h1 className={styles.title}>The Hype</h1>

        <div className={styles.hero}>
          <p className={styles.heroLead}>
            This isn’t “just another app.” This is the start of a platform built around one idea:
            your relationships are valuable—and you should control the data that powers them.
          </p>
          <p className={styles.heroSub}>
            Big things are coming. But the real win is what you can do right now: get your people
            data organized, accurate, and owned by you.
          </p>

          <div className={styles.ctaRow}>
            <Link to="/buy" className={styles.primaryCta}>
              Solve it now (Buy) →
            </Link>
            <Link to="/vision" className={styles.secondaryCta}>
              See the Vision →
            </Link>
            <Link to="/mpd-id" className={styles.secondaryCta}>
              MPD ID Page →
            </Link>
          </div>
        </div>

        <div className={styles.narrative}>
          <h2 className={styles.subtitle}>Why “The Hype” exists</h2>
          <p>
            Most people don’t have a “contacts problem.” They have a relationship context problem:
            scattered notes, outdated details, forgotten follow-ups, and no single source of truth.
          </p>
          <p>
            MyPeopleDatabase is being built as a platform where you can consolidate what you know,
            curate what matters, share selectively, and publish one URL when you choose.
          </p>

          <div className={styles.cardGrid}>
            <div className={styles.card}>
              <div className={styles.cardTitle}>A platform, not a feature</div>
              <div className={styles.cardBody}>
                It starts with a modern contact manager—then expands into a system for identity,
                groups, sharing, and publishing.
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.cardTitle}>Designed for control</div>
              <div className={styles.cardBody}>
                Private by default, built around data ownership, and optimized for clarity—not
                engagement hacks.
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.cardTitle}>Momentum without the mess</div>
              <div className={styles.cardBody}>
                You don’t need to wait for “later” to benefit. Start organizing now and you’ll be
                ready as new capabilities roll out.
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.cardTitle}>Built for real life</div>
              <div className={styles.cardBody}>
                Your network is a long-term asset—family, friends, customers, collaborators.
                Remember people better and act with confidence.
              </div>
            </div>
          </div>

          <div className={styles.sectionBlock}>
            <h2 className={styles.subtitle}>The real pitch</h2>
            <p>
              The future is exciting. But the pain is now: people you should follow up with,
              opportunities you should track, and details you can’t afford to lose.
            </p>
            <p className={styles.closing}>
              Get the foundation right today—so you’re ready for what’s coming tomorrow.
            </p>
          </div>

          <div className={styles.linksSection}>
            <Link to="/buy" className={styles.linkButton}>
              Buy Now →
            </Link>
            <Link to="/features" className={styles.linkButton}>
              Explore Features →
            </Link>
            <Link to="/founders" className={styles.linkButton}>
              Founders Program →
            </Link>
            <Link to="/contact-us" className={styles.linkButton}>
              Talk to us →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
